export const DB_NAME = 'dnd5club';

export const THEME_DB_KEY = 'ttg_theme_name';

export const FULLSCREEN_DB_KEY = 'ttg_detail_fullscreen';

export const USER_TOKEN_COOKIE = 'dnd5_user_token';

export const CONTENT_LAYOUT_FIXED_HEADER_SELECTOR = '.content-layout__fixed';

export default {
  DB_NAME,
  THEME_DB_KEY,
  FULLSCREEN_DB_KEY,
  USER_TOKEN_COOKIE,
};
